import React, { useState, useEffect, useRef } from "react";
// import Nav from "../NavBar/Nav";
import NavNewDark from "../NavBar/NavNewDark";
import NavNew from "../NavBar/NavNew";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Document, Page, pdfjs } from "react-pdf";
import axios from "axios";
import base_url from "../../api/bootapi";
import attachmenturl from "../../api/attachmenturl";
import { useDispatch, useSelector } from "react-redux";
import { Collapse, CardBody, Card } from "reactstrap";
import { getTour, selectTour } from "../Reducers/tourSlice";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import moment from "moment";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import Swal from "sweetalert2";
import { width } from "@mui/system";
import bannerbackground from "../../assets/bannerbackground.jpg";
import Nav from "../NavBar/Nav";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import PdfCanvasView from "./RenderPdf";
import { Select } from "@mantine/core";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function TourTripPdf() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm();
  const priceContainerRef = useRef(null);

  const navigate = useNavigate();
  const formData = new FormData();
  const [viewModal, setViewModal] = useState(false);
  const handleViewModal = () => setViewModal(!viewModal);


  const [backdropopen, setbackdropopen] = useState(false);
  const [tripData, setTripData] = useState();

  const [country1, setcountry] = useState("United States");
  const [countryValid, setCountryValid] = useState(false);

  const [region, setregion] = useState("New York");
  const [regionValid, setRegionValid] = useState(false);

  const [airParticipants, setAirParticipants] = useState(0);
  const [airParticipantStatus, setAirParticipantStatus] = useState(false);
  const [modeStatus, setModeStatus] = useState(false);
  const [nonAirParticipants, setNonAirParticipants] = useState(0);
  const [totalParticipantStatus, setTotalParticipantStatus] = useState(false);

  const [airFarePrice, setAirFarePrice] = useState();
  const [withoutAirFarePrice, setWithoutAirFarePrice] = useState();

  const [tripSeatData, setTripSeatData] = useState([]);
  const [tripSeatData2, setTripSeatData2] = useState([]);

  const [finalParticipants, setFinalParticipants] = useState();
  const [modeOfTour, setModeOfTour] = useState();

  const [paymentMethod, setPaymentMethod] = useState("Card");

  const [imageData, setImageData] = useState();
  const [tourpdfurl, settourpdfurl] = useState("");
  const [tripItineraryUrl, setTripItineraryUrl] = useState(null);
  const [tourstatus, settourstatus] = useState("");

  const [tourTitle, setTourTitle] = useState([]);
  const [fullPackage, setFullPackage] = useState(null);
  const [accommodation, setAccommodation] = useState(null);
  const [singleRoomCost, setSingleRoomCost] = useState(null);
  const [insurancePrice, setInsurancePrice] = useState(null);
  const [isPastTour, setIsPastTour] = useState(true);



  const isMobile = window.innerWidth <= 768;

  const params = useParams();

  const tour_pdf_id = params?.tour_pdf_name;

  const [tourId, setTourId] = useState(null)

  const location = useLocation();

  // const tour_pdf_id = localStorage.getItem("tour_pdf_id");

  const tourDetails = location.state?.tourDetails || null;
  const fromWhereCheck = location.state?.fromWhere || null;
  const tourName = location.state?.tour_names || null;
  const [tourNewName, setTourNewName] = useState(null)
  const [tourNote, setTourNote] = useState(null)
  // console.log(tour_pdf_id)
  // console.log("84", tourName);
  //console.log("85", fromWhereCheck);

  const [subTours, setSubTours] = useState([]);
  const [selectedTour, setSelectedTour] = useState(null);
  const [tourList, setTourList] = useState([])

  const [subTourUrlName, setSubTourUrlName] = useState(null);


  const [mainTourDetails, setMainTourDetails] = useState(null);

  useEffect(() => {
    if (selectedTour) {

      console.log(selectedTour)



      if (selectedTour?.mainTour) {

        console.log(selectedTour?.mainTour)
        settourpdfurl(mainTourDetails?.tour_details)
        setSubTourUrlName(null);

        setFullPackage(mainTourDetails?.full_package_price);
        setAccommodation(mainTourDetails?.accommodation_only_price);
        setSingleRoomCost(mainTourDetails?.single_room_cost);
        setInsurancePrice(mainTourDetails?.insurance_price);
        setTripItineraryUrl(mainTourDetails?.itinerary_details);
        setTourNote(mainTourDetails?.tour_long_descript);
        setTourNewName(mainTourDetails?.tour_names);

      } else {
        const tour = tourList?.find((item) => item?.id === Number(selectedTour?.value))
        // console.log(tour)
        settourpdfurl(tour?.tour_details)

        setSubTourUrlName(tour?.url_name)
        // return
        setFullPackage(tour?.full_package_price);
        setAccommodation(tour?.accommodation_only_price);
        setSingleRoomCost(tour?.single_room_cost);
        setInsurancePrice(tour?.insurance_price);
        setTripItineraryUrl(tour?.itinerary_details);
        setTourNote(tour?.tour_long_descript);
        setTourNewName(tour?.sub_tour_names);

      }


    }
  }, [selectedTour])



  useEffect(() => {
    getAllTourList();

  }, [tour_pdf_id]);

  const getAllTourList = () => {
    setbackdropopen(true);
    axios
      .get(`${base_url.api1}/tourapp/get_trip?url_name=${tour_pdf_id}`)
      .then((response) => {
        // console.log("tour details", response.data.Tour);
        const tour = response.data.Tour[0];
        setFullPackage(tour.full_package_price);
        setAccommodation(tour.accommodation_only_price);
        setSingleRoomCost(tour.single_room_cost);
        setInsurancePrice(tour.insurance_price);

        let mainTour = {
          full_package_price: tour.full_package_price,
          accommodation_only_price: tour.accommodation_only_price,
          single_room_cost: tour.single_room_cost,
          insurance_price: tour.insurance_price,
          tour_long_descript: tour.tour_long_descript,
          tour_names: tour.tour_names
        }
        setTourNewName(tour.tour_names);
        setTourNote(tour.tour_long_descript)

        // "tour_status": "InActive",
        const tour_id = tour.id
        setTourId(tour_id);

        if (tour.tour_status === "Active") {
          setIsPastTour(false);
        }

        axios.get(`${base_url.api1}/tourapp/trip_list`, {}).then(
          (response) => {
            //console.log("100", response.data.tour);
            // setupcomingTourName(response.data.tour);
            document.getElementById("myForm").reset();
            // Find the object with matching id
            const matchingObject = response?.data?.tour?.find(
              (obj) => obj.id == tour_id
            );

            // Check if a matching object was found
            if (matchingObject) {
              //console.log("Matching tour_names:", matchingObject);
              setTripItineraryUrl(matchingObject.itinerary_details)
              settourpdfurl(matchingObject.tour_details);
              mainTour.tour_details = matchingObject.tour_details
              mainTour.itinerary_details = matchingObject.itinerary_details
              settourstatus(matchingObject.tour_status);
            }
            setbackdropopen(false);
          },
          (error) => {
            settourpdfurl(null);
            setbackdropopen(false);

            //console.log(JSON.stringify(error.response.data));
          }
        );

        setMainTourDetails(mainTour)
        const listItem = [{
          value: String(tour_id),
          label: tour?.tour_names ? tour?.tour_names : "Main Tour", // Adjust key as per your API response
          mainTour: true
        }]

        setSelectedTour({
          value: String(tour_id),
          label: tour?.tour_names ? tour?.tour_names : "Main Tour",
          mainTour: true
        })

        setSubTours(listItem);
      })
      .catch((err) => {
        setbackdropopen(false);
      });
  };

  useEffect(() => {
    if (tourId) {
      getAllSubTourList()
    }
  }, [tourId])


  const getAllSubTourList = () => {
    setbackdropopen(true);
    axios
      .get(`${base_url.api1}/tourapp/subtour/by_tour/${tourId}`)
      .then((subRes) => {


        const subs = subRes.data.SubTour || [];

        const formattedSubTours = subRes.data.SubTour.map((item, index) => ({
          value: String(item.id),
          label: item?.sub_tour_names ? item?.sub_tour_names : `Sub Tour ${item.id} (${item.tour_duration})`, // Adjust key as per your API response
          mainTour: false
        }));

        setTourList(subs)

        setSubTours(prev => [...prev, ...formattedSubTours])
      })
      .catch((err) => {
        setbackdropopen(false);
      }).finally(() => {
        setbackdropopen(false);

      })
  };
  const getTourDetail = () => {
    axios
      .get(`${base_url.api1}/tourapp/get_trip?id=${tour_pdf_id}`)
      .then((response) => {
        setFullPackage(response.data.Tour.full_package_price);
        setAccommodation(response.data.Tour.accommodation_only_price);
      })
      .catch((err) => { });
  };

  const pdfurl = location.state?.tourDetails;
  const fullURL = tourpdfurl ? `${attachmenturl}${tourpdfurl}` : null;
  const fullItinerary = tripItineraryUrl ? `${attachmenturl}${tripItineraryUrl}` : null;
  // console.log(fullURL)
  const Testurl = "https://purple-bertina-48.tiiny.site";

  const [file, setFile] = useState(null);


  useEffect(() => {
    if (!tourpdfurl) return;

    const fullURL = tourpdfurl ? `${attachmenturl}${tourpdfurl}` : null
    const loadPdf = async () => {
      const response = await fetch(fullURL, { mode: "cors" });
      const blob = await response.blob();
      setFile(URL.createObjectURL(blob));
    };

    loadPdf();
  }, [tourpdfurl]);



  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  // const printIframe = (id) => {
  //     //console.log(id);
  //     const iframe = document.frames
  //         ? document.frames[id]
  //         : document.getElementById(id);
  //     const iframeWindow = iframe.contentWindow || iframe;

  //     iframe.focus();
  //     iframeWindow.print();
  //     return false;
  // };

  const pdfToImage = async (pdfUrl) => {
    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1); // Render the first page, or loop if multiple pages are needed

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    await page.render(renderContext).promise;

    // Convert canvas to an image URL
    return canvas.toDataURL();
  };

  const printIframe = async (pdfUrl, priceHTML) => {

    // console.log(pdfUrl, priceHTML)
    try {
      // Set loading state
      setbackdropopen(true);

      // Convert the PDF to an image
      const imageUrl = await pdfToImage(pdfUrl);

      // Create an invisible iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // Get the iframe's document
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      // Write the content to the iframe's document
      iframeDoc.open();
      iframeDoc.write(`
        <html>
          <head>
            <style>
              body {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;
              }
              img {
                width: 100%;
                max-height: 1140px;
                object-fit: contain;
                border: 2px solid black;
              }
              .price-container {
                margin-top: 20px;
              }
            </style>
          </head>
          <body>
            <img src="${imageUrl}" />
          
          </body>
        </html>
      `);
      iframeDoc.close();
      //   <div class="price-container">
      //   ${priceHTML}
      // </div>
      // Wait for the content to be fully loaded and then print
      iframe.onload = () => {
        setbackdropopen(false);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Remove the iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    } catch (error) {
      // Handle any errors
      setbackdropopen(false);
      console.error("Error occurred while printing the iframe:", error);
    }
  };

  // const printIframe = (id, divcontents) => {
  //     var content = document.getElementById(divcontents); // Use the passed divcontents variable
  //     var pri = document.getElementById(id).contentWindow; // Use the passed id variable
  //     pri.document.open();
  //     pri.document.write(content.innerHTML);
  //     pri.document.close();
  //     pri.focus();
  //     pri.print();
  // };

  const handleEnrollmentClick = () => {
    // Navigate to the specified pathname on button click
    if (subTourUrlName) {
      navigate({
        pathname: `/enrollment/${tour_pdf_id}/${subTourUrlName}`,
        state: { tour_names: tourName },
      });
    } else {
      navigate({
        pathname: `/enrollment/${tour_pdf_id}/`,
        state: { tour_names: tourName },
      });
    }

  };

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />

        <div className="container">
          <div
            className="page-head d-flex justify-content-between pb-4 pt-4"
            style={{ marginTop: "1.3rem" }}
          >
            <ul className="breadcrums">
              <Link to="/" className="b-link">
                Home
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" className="b-link">
                Linsoa Tours
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" className="b-link active">
                {isPastTour ? "Past Tours" : "Upcoming Tours"}
              </Link>
            </ul>

          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              minWidth: "108%",
            }}
            className="mobile-view-tour-trip"
          >
            <div style={{ flex: 1, position: "relative" }} className="mobile-tour-trip-pdf">

              {tourNewName && <h3 className="tour-name-new">{tourNewName}</h3>}


              <Carousel>
                {tourpdfurl == null ? (
                  <img
                    src="No_image_available.png"
                    width="200"
                    height="200"
                    alt="No image available"
                  />
                ) : (
                  <div style={{ minHeight: isMobile ? "initial" : '1000px' }}>

                    {
                      isMobile ? <PdfCanvasView fileUrl={fullURL} />
                        :
                        fullURL && <iframe
                          id="tourpdf"
                          src={`${fullURL}#view=FitH`}
                          width="100%"
                          height="1150px"
                          style={{ border: 'none' }}
                        />


                      // <PdfCanvasView fileUrl={fullURL} />
                    }




                    {/* <PdfCanvasView fileUrl={fullURL} /> */}



                    <div
                      style={{
                        display: "flex",
                        marginTop: "1rem",
                        paddingTop: "0.5rem",
                        marginLeft: "2.5rem",
                        justifyContent: "center",
                      }}
                      className="price-container"
                    >
                      {fullPackage && (
                        <div style={{ marginRight: "2rem", width: "200px" }}>
                          <label>Full Package</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              id="fullPackage"
                              className="form-control underline-input"
                              value={`$ ${fullPackage}`}
                              readOnly
                            />
                          </div>
                        </div>
                      )}
                      {accommodation && (
                        <div style={{ marginRight: "2rem", width: "200px" }}>
                          <label>Accommodation only</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control underline-input"
                              value={`$ ${accommodation}`}
                              readOnly
                            />
                          </div>
                        </div>
                      )}


                      {singleRoomCost && (
                        <div style={{ marginRight: "2rem", width: "200px" }}>
                          <label>Private Room Cost</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control underline-input"
                              value={`$ ${singleRoomCost}`}
                              readOnly
                            />
                          </div>
                        </div>
                      )}


                      {insurancePrice && (
                        <div style={{ width: "200px" }}>
                          <label>Travel Insurance</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control underline-input"
                              value={`$ ${insurancePrice}`}
                              readOnly
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {tourpdfurl != null && isMobile && (
                      <div
                        className="mobile-tour-trip-buttons"
                        style={{
                          width: "250px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          marginLeft: "20px",
                          marginTop: "20px"// Adds space between the iframe and buttons
                        }}
                      >

                        {tourstatus === "Active" && (
                          <Button
                            variant="primary"
                            onClick={handleEnrollmentClick}
                            style={{
                              fontWeight: "bold",
                              borderRadius: "40px",
                              padding: "10px 35px",
                              backgroundColor: "#00627e",
                            }}
                          >
                            Enrollment
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </Carousel>
            </div>




            <div
              className="mobile-tour-trip-buttons"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginLeft: "20px", // Adds space between the iframe and buttons
              }}
            >

              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '16px', fontWeight: '600', color: "#222", textAlign: 'center' }}>Tours</h1>

                {
                  subTours?.map((t) => {
                    return <button className={t?.value === selectedTour?.value ? 'tour-button-show tour-button-show-active' : 'tour-button-show'} onClick={() => setSelectedTour(t)}>
                      {t?.label}
                    </button>
                  })
                }

              </div>

              {/* <Select
                label="Select Tour"
                placeholder="Select Tour"
                defaultValue={''}
                value={selectedTour?.value}
                onChange={(_value, option) => {
                  setSelectedTour(option);
                  console.log(option); // { value: "...", label: "..." }
                }}
                data={subTours}
                w="100%"
                allowDeselect={false}
                comboboxProps={{
                  transitionProps: {
                    transition: 'pop',
                    duration: 150,
                  },
                }}
                styles={{
                  label: {
                    fontSize: '16px',
                    fontWeight: 600,
                    marginBottom: 6,
                  },
                  input: {
                    fontSize: '15px',
                  },
                }}
              /> */}

              {tourpdfurl != null && <>
                {tourstatus === "Active" && (
                  <Button
                    variant="primary"
                    onClick={handleEnrollmentClick}
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",
                      padding: "15px 35px",
                      marginTop: '25px',
                      backgroundColor: "#00627e",
                      fontSize: '17px'
                    }}
                  >
                    Enrollment
                  </Button>
                )}

                {
                  tourNote && <span className="tour-note">
                    <b>Note: </b>
                    {tourNote}
                  </span>
                }

                <div className="print-btn-container">
                  <Button
                    variant="contained"
                    onClick={() => {
                      const priceHTML =
                        document.querySelector(".price-container").outerHTML;
                      printIframe(fullURL, priceHTML);
                    }}
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",
                      padding: "10px 35px",
                      marginTop: '30px',
                      backgroundColor: "#00627e",
                      marginBottom: "10px", // Adds space between the buttons
                    }}


                  >
                    Print PDF
                  </Button>

                  {/* {tripItineraryUrl && ( */}
                  <Button
                    variant="primary"
                    onClick={() => {
                      if (tripItineraryUrl) {
                        if (subTourUrlName) {
                          window.open(`/itinerary/${tour_pdf_id}/${subTourUrlName}`, '_blank');

                        } else {

                          window.open(`/itinerary/${tour_pdf_id}`, '_blank');
                        }
                        // window.open(`${attachmenturl}${tripItineraryUrl}`, '_blank')
                      }
                    }}
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",

                      padding: "10px 35px",
                      backgroundColor: "#00627e",
                    }}
                  >
                    Trip Itinerary
                  </Button>
                  {/* )} */}
                </div>
              </>

              }




            </div>








          </div>

          <div className="tourdetails_grid"></div>
        </div>
        <FooterNew />
      </React.Fragment>
    </div>
  );
}
